import React, { useState } from "react";
import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import {
  CustomerSearchCriteria,
  PageListBean,
  RestCustomerListRequest,
  RestReadRequest,
  SalesOrderSearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import { CancelIcon } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  ColumnDefinition,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyArray } from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCustomerModule,
  PopupSalesModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CustomerService } from "../services/CustomerService.js";
import { SalesOrderService } from "../services/SalesOrderService.js";
import { ModuleUtils } from "./ModuleUtils.js";
import CustomTable from "../gui_components/CustomTable.js";
class MassCancelSalesOrder extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Mass Cancel SalesOrder",
      isShowExecuteButton: true,
      isShowResetButton: false,
      isShowExitButton: true,
      isShowClearCriteriaButton: true,
      customerLookupHandler: null,
      cancelSoDataList: [],
      selectedItemList: [],
      error_list: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      criteria: new SalesOrderSearchCriteria(),
      criteriaViewShow: false,
      pageList: new PageListBean(),
      isCancelSoDatasFound: false,
      isShowCancelButton: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowSalesModule: false,
      isShowCustomerModule: false,
      moduleForPopup: [],
      companyCode: "",
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      isNoData: false,
      isDisableFields: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
    ModuleUtils.getSalesOrderStatusList();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  handleResponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription)
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.criteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.criteria;
      tempData.customerCode = "";
      tempData.customerName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        criteria: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      setTimeout(() => {
        this.readCustomerBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ criteria: tempData });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.errorCallBack
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    this.state.isShowAutoCompleteCustomerList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerByCustomerCodeResponse = (response) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading Data...",
    });
    let customerData = response.data.customer;
    let criteria = this.state.criteria;
    criteria.customerCode = customerData.code;
    criteria.customerName = customerData.description;
    this.setState({
      criteria: criteria,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    CustomerService.readCustomer(
      readrestInput,
      this.readCustomerByCustomerCodeResponse,
      this.errorCallBack
    );
  };
  loadPage = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.loadMassCancelSalesOrderList(criteria);
  };
  loadMassCancelSalesOrderList = (listRequest) => {
    if (SecurityAccessManager.MassCancelSalesOrder_IsAccessible()) {
      SalesOrderService.getOpenSalesOrderLinesForMassMaintenance(
        listRequest,
        this.loadMassCancelSalesOrderPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadMassCancelSalesOrderPageResponse = (response) => {
    this.showErrorMessage(response.data);
    let cancelSoDataList = new Array();
    if (
      !isEmpty(response.data) &&
      !isEmptyArray(response.data.massSalesOrderBean)
    ) {
      const massSalesOrderBean = response.data.massSalesOrderBean;
      massSalesOrderBean.map((bean) => {
        if (bean.status == LogicConstants.SALES_ORDER_APPROVE_STATUS) {
          cancelSoDataList.push(bean);
        }
      });
      this.setState({
        isCancelSoDatasFound: true,
        isShowCancelButton: true,
        cancelSoDataList: cancelSoDataList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        isNoData: false,
      });
      this.disable();
    } else {
      this.setState({
        isCancelSoDatasFound: false,
        isShowCancelButton: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
        isNoData: true,
      });
    }
  };
  errorCallBack = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  execute = () => {
    this.loadPage(1);
    this.clearError();
    this.hideAlertCallBack();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      customerPageListForAutoCompleteList: new Array(),
      isNoData: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
  };
  resetView = () => {
    let criteria = new SalesOrderSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isCancelSoDatasFound: false,
      isShowCancelButton: false,
      cancelSoDataList: new Array(),
      customerPageListForAutoCompleteList: new Array(),
      selectedItemList: [],
      isNoData: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewCustomerModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  viewSalesModule = (e, code, rowData) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowSalesModule: true,
        moduleForPopup: (
          <PopupSalesModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowCustomerModule: isOpen,
      moduleForPopup: [],
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  cancelSalesOrder = (e) => {
    if (e.detail == 1) {
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Cancelling SalesOrder...",
      });
      let selectedItemList = this.state.selectedItemList;
      let itemList = [];
      for (let list of selectedItemList) {
        itemList.push(list.salesOrderNumber);
      }
      let criteria = new SalesOrderSearchCriteria();
      criteria.companyCode = this.companyCode;
      criteria.salesOrderNumbers = itemList;
      criteria.companyCode = this.companyCode;
      if (SecurityAccessManager.MassCancelSalesOrder_IsAccessible()) {
        SalesOrderService.cancelMassSalesOrder(
          criteria,
          this.canceSalesOrderResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(1);
      }
    }
  };
  canceSalesOrderResponse = (response) => {
    let isSuccess = this.handleCancelResponse(response.data);
    if (isSuccess) {
      this.setState({
        selectedItemList: [],
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.loadPage();
    this.setState({
      selectedItemList: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  handleCancelResponse = (response) => {
    let isSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.infos != null) {
      response.infos.map(
        (info) => (infoMsg = infoMsg + "\n" + info.messageDescription)
      );
      let successMsg = [];
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
      });
      isSuccess = true;
    }
    if (response.errors != null) {
      response.errors.map(
        (err) => (
          (errMsg = errMsg + "\n" + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      isSuccess = false;
    }
    this.setState({ error_list: errList });
    return isSuccess;
  };
  getCaption = (status) => {
    return ModuleUtils.getSalesOrderStatusCaption(status);
  };
  soColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("", "isActive", false)
        .setInputDetails(false, false, true, null, this.selectedOnChange, null)
        .setStyleDetails("", "", "", "wt-1-5 ", "wt-1-5 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesOrderNumber#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewSalesModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cust P.O", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setClickDetails(true, false, this.viewCustomerModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
        .setStatusDetails(true, this.getCaption)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StartDate", "salesOrderStartDate", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "salesOrderStopDate", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 ")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "amount", true, true)
        .setStyleDetails("right", "", "", "wt-4 ", "wt-4 ")
    );

    return columns;
  };
  columnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition()
        .setDetails(
          "",
          "isActive",
          0,
          false, //set hyperlink false
          null, //set hyperLink call back null
          false,
          null
        )
        .setEditableDetails(
          false,
          "",
          null,
          false,
          null,
          true,
          this.selectedOnChange
        )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "SalesOrderNumber#",
        "salesOrderNumber",
        0,
        true,
        this.viewSalesModule
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Cust P.O",
        "customerPurchaseOrderNumber",
        0,
        false,
        null,
        false,
        null,
        "1rem",
        "20rem"
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Customer",
        "customerCode",
        0,
        true,
        this.viewCustomerModule,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "CustomerName",
        "customerName",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Status",
        "status",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "15%", //max-width
        true,
        ModuleUtils.getSalesOrderStatusCaption
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StartDate",
        "salesOrderStartDate",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "StopDate",
        "salesOrderStopDate",
        0,
        false,
        null,
        false,
        null
      )
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Amount",
        "amount",
        1,
        false,
        null,
        false,
        null
      )
    );
    return columnList;
  };
  selectAllItem = (e) => {
    if (e.detail == 1) {
      let list = this.state.cancelSoDataList;
      list.map((line) => {
        line.isActive = true;
      });
      this.setState({ selectedItemList: list });
    }
  };
  unSelectAllItem = (e) => {
    if (e.detail == 1) {
      let list = this.state.cancelSoDataList;
      list.map((line) => {
        line.isActive = false;
      });
      this.setState({ selectedItemList: [] });
    }
  };
  selectedOnChange = (e, rowData) => {
    let selectedItemList = this.state.selectedItemList;
    rowData.isActive = e.target.value;
    if (rowData.isActive === true) {
      selectedItemList.push(rowData);
      this.setState({ selectedItemList: selectedItemList });
    } else {
      let selectedItemList = this.state.selectedItemList;
      let invList = [];
      for (let item of selectedItemList) {
        if (item.isActive != rowData.isActive) {
          invList.push(item);
          this.setState({ selectedItemList: invList });
        } else if (selectedItemList.length == 1) {
          this.setState({ selectedItemList: [] });
        }
      }
    }
  };
  render() {
    let cancelSoDataList = this.state.cancelSoDataList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          extend_toolbar={
            <>
              {this.state.isShowCancelButton && (
                <Button
                  className="header_buttons secondary"
                  size="sm"
                  onClick={(e) => this.cancelSalesOrder(e)}
                >
                  {" "}
                  <CancelIcon />
                  Cancel{" "}
                </Button>
              )}
            </>
          }
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          clearCriteria={this.clearCriteria}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowExitButton={this.state.isShowExitButton}
          pageTitle={this.state.pageTitle}
          execute={this.execute}
          reset={this.resetView}
          onModuleExit={this.moduleExit}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          onCustomerCodeChange={this.onCustomerCodeChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCustomerCompleteList={this.displayAutoCustomerCompleteList}
        />
        {this.state.isCancelSoDatasFound && (
          <div>
            <Row>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.selectAllItem(e)}
                >
                  {" "}
                  SelectAll{" "}
                </Button>
              </Col>
              <Col sm="1">
                <Button
                  id="fabric_Add_Button"
                  size="sm"
                  onClick={(e) => this.unSelectAllItem(e)}
                >
                  {" "}
                  UnSelectAll{" "}
                </Button>
              </Col>
            </Row>
          </div>
        )}
        {this.state.isCancelSoDatasFound && (
          <div className="div_default">
            {/* <EditableDataGrid
              columnsList={this.columnDefinitions()}
              dataList={cancelSoDataList}
            /> */}
            <CustomTable
              columns={this.soColumns()}
              data={cancelSoDataList}
              label={"Sales List"}
            />
          </div>
        )}
        {this.state.isNoData && <div className="no_Data">{"NO DATA"}</div>}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const onCustomerCodeChange = (e) => props.onCustomerCodeChange(e);
  const customerCodeEnterKeyEventHandler = (e) =>
    props.customerCodeEnterKeyEventHandler(e);
  const displayAutoCustomerCompleteList = (list) =>
    props.displayAutoCustomerCompleteList(list);
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  let customerCodeRef = React.createRef();
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={customerCodeRef}
            name="customerCode"
            onChange={onCustomerCodeChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCustomerCompleteList}
            showAutoCompleteList={props.isShowAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="customerName"
            type="text"
            onChange={onChange}
            value={criteria.customerName}
            readOnly={true}
          />
        </Col>
      </Row>
    </div>
  );
}
function MassCancelSalesOrderModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <MassCancelSalesOrder {...props} name="" /> <br />
      </div>
    </div>
  );
}

export default MassCancelSalesOrderModule;
